module.exports = __webpack_public_path__ + "img/fangzhenbig.35851df4.gif";